import React, { Component } from "react";
import { ShippingAddressChangeControl } from "controls/ShippingAddressChangeControl";
import { BillingAddressChangeControl } from "controls/BillingAddressChangeControl";
import { CtrlCollection } from "@yuigoto/ctrl";
import { ControlRenderer } from "components/renderers/ControlRenderer";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { connect } from "react-redux";
import { UiActions } from "state/actions/UiActions";

class AddressChange extends Component {
  constructor(props) {
    super(props);

    this.updateCep = this.updateCep.bind(this);
    this.autofillFields = this.autofillFields.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.getBillingInfo = this.getBillingInfo.bind(this);
    this.setCollectionBillingValue = this.setCollectionBillingValue.bind(this);
    this.setCollectionShippingValue = this.setCollectionShippingValue.bind(
      this
    );
    this.showValidationMessage = this.showValidationMessage.bind(this);

    //this.addressRequest = this.addressRequest.bind(this);

    this.state = {
      validationMessage: "",
      subscriptionInfo: this.props.subscriptionInfo,
      billingData: {},
      dataChanged: false,
      shippingStateId: 0,
      shippingCityId: 0,
      wasChanged: false
    };

    this.collection = new CtrlCollection();
    if (this.props.type === 1) {
      for (let i = 0; i < ShippingAddressChangeControl.length; i++) {
        if (ShippingAddressChangeControl[i].name === "shippingPostalCode") {
          ShippingAddressChangeControl[i].onChange = this.updateCep;
        } else {
          ShippingAddressChangeControl[i].onChange = this.checkChange;
        }

        this.collection.add(ShippingAddressChangeControl[i]);
      }
    } else if (this.props.type === 2) {
      for (let i = 0; i < BillingAddressChangeControl.length; i++) {
        if (BillingAddressChangeControl[i].name === "BillingPostalCode") {
          BillingAddressChangeControl[i].onChange = this.updateCep;
        } else {
          ShippingAddressChangeControl[i].onChange = this.checkChange;
        }

        this.collection.add(BillingAddressChangeControl[i]);
      }
    }
  }

  showValidationMessage() {
    const validationMessage = this.state.validationMessage;
    return <h3>{validationMessage}</h3>;
  }

  checkChange = () => {
    if (this.state.wasChanged === false) {
      this.setState(
        {
          wasChanged: true
        },
        () => {
          //console.log(this.state.wasChanged);
        }
      );
    }
  };

  getBillingInfo() {
    ExecuteRequest(
      GlamboxEndpoints.Subscriber.detail,
      null,
      "GET",
      {
        Authorization: this.props.token.Authorization
      },
      {
        subscriberId: this.props.subscriptionInfo.id
      },
      (response) => {
        const {
          result,
          statusCode
        } = response;

        if (statusCode === 200) {
          this.setState({
            billingData: result
          });

          this.setCollectionValue();
        } else {
          // TODO
        }
      }
      // Object.assign(
      //   {},
      //   {},
      //   {
      //     subscriber_id: 262135, //Arrumar
      //     access_token: this.props.token.data.access_token
      //   }
      // ),
      // (result, error) => {
      //   if (result.resultType === "SUCCESS") {
      //     this.setState({ billingData: result.result });
      //     this.setCollectionValue();
      //   } else {
      //     //TODO
      //   }
      // }
    );
  }

  setCollectionBillingValue() {
    this.collection.setValue(
      "BillingPostalCode",
      this.state.billingData.subscriber.billingPostalCode
    );
    this.collection.setValue(
      "BillingCity",
      this.state.billingData.subscriber.billingCity
    );
    this.collection.setValue(
      "BillingNeighborhood",
      this.state.billingData.subscriber.billingNeighborhood
    );
    this.collection.setValue(
      "BillingStreet",
      this.state.billingData.subscriber.billingStreet
    );
    this.collection.setValue(
      "BillingStreetNumber",
      this.state.billingData.subscriber.billingStreetNumber
    );
    this.collection.setValue(
      "BillingStreetExtensions",
      this.state.billingData.subscriber.billingStreetExtensions
    );
    this.collection.setValue(
      "shippingName",
      this.props.user.person.data.person.firstName +
      " " +
      this.props.user.person.data.person.lastName
    );
    this.collection.setValue(
      "shippingPhone",
      this.props.user.person.data.person.phone
    );
    this.forceUpdate();
  }

  setCollectionShippingValue() {
    this.collection.setValue(
      "shippingPostalCode",
      this.state.subscriptionInfo.shippingPostalCode
    );
    this.collection.setValue(
      "uf",
      this.state.subscriptionInfo.shippingstateCode
    );
    this.collection.setValue(
      "shippingCity",
      this.state.subscriptionInfo.shippingCity
    );
    this.collection.setValue(
      "shippingStreetNeighborhood",
      this.state.subscriptionInfo.shippingNeighborhood
    );
    this.collection.setValue(
      "shippingStreet",
      this.state.subscriptionInfo.shippingstreet
    );
    this.collection.setValue(
      "shippingStreetNumber",
      this.state.subscriptionInfo.shippingStreetNumber
    );
    this.collection.setValue(
      "shippingStreetExtension",
      this.state.subscriptionInfo.shippingStreetExtensions
    );
    this.collection.setValue(
      "shippingName",
      this.state.subscriptionInfo.shippingName
    );
    this.collection.setValue(
      "shippingPhone",
      this.state.subscriptionInfo.shippingPhone
    );

    this.forceUpdate();
  }

  componentDidMount() {
    if (this.props.type === 1) {
      this.setCollectionShippingValue();
    } else if (this.props.type === 2) {
      this.getBillingInfo();
    }
  }

  autofillFields(result) {
    if (this.props.type === 1) {
      this.collection.setValue("shippingCity", result.cidade);
      this.collection.setValue("shippingStreetNeighborhood", result.bairro);
      this.collection.setValue("shippingStreet", result.logradouro);
      this.collection.setValue("uf", result.codigoIbgeEstado);
      this.collection.setValue("shippingStreetNumber", "");
      this.collection.setValue("shippingStreetExtensions", "");
    } else if (this.props.type === 2) {
      this.collection.setValue("billingCity", result.cidade);
      this.collection.setValue("billingNeighborhood", result.bairro);
      this.collection.setValue("billingStreet", result.logradouro);
      this.collection.setValue("billingStreetNumber", "");
      this.collection.setValue("billingStreetExtensions", "");
      this.collection.setValue(
        "shippingName",
        this.props.user.person.data.person.firstName +
        " " +
        this.props.user.person.data.person.lastName
      );
      this.collection.setValue(
        "shippingPhone",
        this.props.user.person.data.person.phone
      );
    }

    this.forceUpdate();
  }

  getRequiredFields = result => {
    this.setState({
      subscriptionInfo: result,
      dataChanged: true,
      shippingStateId: result.codigoIbgeEstado,
      shippingCityId: result.codigoCepCidade
    });
  };

  addressRequest = (cepValue, isSubmit, optionalCallback) => {
    ExecuteRequest(
      GlamboxEndpoints.Open.locationFromCep,
      {},
      "GET",
      null,
      {
        cep: cepValue
      },
      response => {
        const { result, statusCode } = response;

        if (statusCode === 200) {
          this.getRequiredFields(result);

          if (!this.verifyUniqueCep(cepValue)) {
            this.autofillFields(result);
          } else if (!isSubmit) {
            this.clearOldData();
          }
        }
      }
    );
  };

  clearOldData = () => {
    this.collection.setValue("shippingCity", "");
    this.collection.setValue("shippingStreetNeighborhood", "");
    this.collection.setValue("shippingStreet", "");
    this.collection.setValue("shippingStreetNumber", "");
    this.collection.setValue("shippingStreetExtensions", "");
    this.forceUpdate();
  };

  verifyUniqueCep = value => {
    return /0{3}$/.test(value.trim());
  };

  updateCep = async (event, value) => {
    this.setState(
      {
        wasChanged: true
      },
      async () => {
        if (value.length >= 8) {
          let response = await ExecuteRequest(
            GlamboxEndpoints.Open.locationFromCep,
            {},
            "GET",
            null, {
            cep: value
          }
          );

          const {
            result,
            statusCode
          } = response;

          if (statusCode === 200) {
            this.getRequiredFields(result);

            if (!this.verifyUniqueCep(value)) {
              this.autofillFields(result);
            } else {
              this.clearOldData();
            }
          }
        }
      }
    );

    // this.setState(
    //   {
    //     wasChanged: true
    //   },
    //   () => {
    //     if (value.length >= 8) {
    //       console.log("A");
    //       this.addressRequest(value);
    //     }
    //
    //     console.log(this.collection);
    //
    //     console.log("UPDATECEP");
    //   }
    // );
  };

  onSubmit(event) {
    event.preventDefault();

    let currentCep = this.collection.getValue("shippingPostalCode");

    if (this.state.wasChanged) {
      let isValid = this.collection.validate();
      if (isValid) {
        let isSubmit = true;
        this.addressRequest(currentCep, isSubmit);

        if (this.props.type === 1) {
          let currentStateCode =
            this.state.shippingStateId === 0
              ? this.props.subscriptionInfo.shippingstateCode
              : this.state.shippingStateId;
          let currentCityCode =
            this.state.shippingCityId === 0
              ? this.props.subscriptionInfo.shippingCityCode
              : this.state.shippingCityId;

          ExecuteRequest(
            GlamboxEndpoints.Subscriber.addressChange,
            Object.assign(
              {},
              this.collection.toObject(),
              {
                shippingStateId: currentStateCode,
                shippingCityId: currentCityCode,
                subscriberId: this.props.subscriptionInfo.id
              }
            ),
            "PUT",
            {
              Authorization: this.props.token.Authorization,
            },
            null,
            (response) => {
              const {
                result,
                statusCode
              } = response;

              if (statusCode === 200) {
                this.props.successAlert(
                  result && result.message
                    ? result.message
                    : "Dados de endereço atualizados com sucesso."
                );

                this.props.callback(result.result);

                this.props.onCloseModal();
              } else {
                this.props.errorAlert(
                  result && result.message
                    ? result.message
                    : "Não foi possível atualizar os dados de endereço. Por favor, tente novamente."
                );
              }
            }
          );
        }
      } else {
        this.props.errorAlert("Verifique o preenchimento dos campos");
      }
    } else {
      this.props.errorAlert("Nada alterado");
      this.props.onCloseModal();
    }
  }

  render() {
    return (
      <div>
        <form>
          <p><small>* Campo Obrigatório</small></p>

          {ControlRenderer.renderCollection(this.collection)}
          <input type="submit" onClick={this.onSubmit}></input>
          {this.showValidationMessage()}
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.token.data
  };
};

const mapDispatchToProps = dispatch => {
  return {
    successAlert: message => {
      dispatch(UiActions.publishSuccessAlert(message));
    },
    errorAlert: message => {
      dispatch(UiActions.publishErrorAlert(message));
    }
  };
};

AddressChange = connect(mapStateToProps, mapDispatchToProps)(AddressChange);

export { AddressChange };